import { usePunditUserContext } from "@circle-react/contexts";

export const useAreAiWorkflowTemplatesEnabled = (): boolean => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.ai_automations_enabled);
};
